import { Col, Container } from "react-grid-system";
import { Link } from "react-router-dom";
import { Button } from "../../components/Button";
import { Decision } from "../../components/Decison";
import ArrowIcon from "../../assets/img/icons/arrow-prev.svg";
import CloseIcon from "../../assets/img/icons/close.svg";
import Bar from "../../components/Bar/Bar";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { useState, useEffect } from "react";
import { theme } from "../../styles/theme";
import { CloseBtn } from "../../components/CloseBtn";
import { toast } from "react-toastify";
import { PrefillDecisionManager } from "../../utils/PrefillDecisionManager";

export default function AddDecisionPage() {
	const [isEditMode, setIsEditMode] = useState(false);
	const [prefillData, setPrefillData] = useState(null);

	useEffect(() => {
		// Check for prefilled data from document upload using PrefillDecisionManager
		console.log("🔍 AddDecisionPage: Checking for prefilled data...");
		console.log("🔍 AddDecisionPage: SessionStorage prefillDecisionData:", sessionStorage.getItem("prefillDecisionData"));
		
		let prefillDecisionData = null;
		
		// Try PrefillDecisionManager first
		try {
			prefillDecisionData = PrefillDecisionManager.load();
			console.log("🔍 AddDecisionPage: Prefill data loaded via PrefillDecisionManager:", prefillDecisionData);
		} catch (error) {
			console.error("🔍 AddDecisionPage: PrefillDecisionManager.load() failed:", error);
		}
		
		// Fallback to direct sessionStorage access
		if (!prefillDecisionData) {
			try {
				const storedData = sessionStorage.getItem("prefillDecisionData");
				if (storedData) {
					prefillDecisionData = JSON.parse(storedData);
					console.log("🔍 AddDecisionPage: Prefill data loaded via fallback sessionStorage:", prefillDecisionData);
				}
			} catch (error) {
				console.error("🔍 AddDecisionPage: Fallback sessionStorage access failed:", error);
			}
		}
		
		const toastShown = sessionStorage.getItem("documentToastShown");
		console.log("🔍 AddDecisionPage: Toast shown status:", toastShown);
		
		if (prefillDecisionData && !toastShown) {
			try {
				console.log("🔍 AddDecisionPage: Setting prefill data:", prefillDecisionData);
				setPrefillData(prefillDecisionData);
				
				// Show simple toast notification for successful document processing
				if (prefillDecisionData.metadata?.sourceFiles && prefillDecisionData.metadata.sourceFiles.length > 0) {
					const sourceFile = prefillDecisionData.metadata.sourceFiles[0];
					
					toast.success(
						`Document "${sourceFile.name}" processed successfully. Please review the prefilled fields.`,
						{
							position: "top-right",
							autoClose: 5000,
							hideProgressBar: false,
							closeOnClick: true,
						}
					);
					// Mark toast as shown to prevent duplicates
					sessionStorage.setItem("documentToastShown", "true");
				}
			} catch (error) {
				console.error("Error loading prefilled decision data:", error);
				if (!toastShown) {
					toast.error("Error processing document data. Please try uploading again.", {
						autoClose: 10000
					});
					sessionStorage.setItem("documentToastShown", "true");
				}
			}
		}
	}, []); // Empty dependency array

	return (
		<>
			{isEditMode ? (
				<>
					<Bar bg={theme.color.blue0} fullWidth infobar={true}>
						<Col>
							<p>Edit mode</p>
						</Col>
						<Col>
							<div className="d-flex justify-content-end">
								<CloseBtn onClick={() => setIsEditMode(false)} icon={CloseIcon} />
							</div>
						</Col>
					</Bar>
				</>
			) : (
				<Bar fullWidth>
					<Link to="/">
						<Button bg={false} small icon={ArrowIcon}>
							Back
						</Button>
					</Link>
					<Breadcrumbs />
				</Bar>
			)}
			<Container>
				<Decision 
					newDecision 
					isEditMode={isEditMode} 
					setIsEditMode={setIsEditMode}
					prefillData={prefillData}
				/>
			</Container>
		</>
	);
}
